import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const ChartBarIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "chart-bar",
  "ChartBarIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M8.6665 2L13.3332 2L13.3332 14.6667L8.6665 14.6667L8.6665 2ZM9.99984 3.33333L9.99984 13.3333H11.9998L11.9998 3.33333L9.99984 3.33333Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M2.6665 6L7.33317 6L7.33317 14.6667L2.6665 14.6667L2.6665 6ZM3.99984 7.33333L3.99984 13.3333H5.99984L5.99984 7.33333L3.99984 7.33333Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default ChartBarIcon;
